import * as React from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';

import { cn } from '@blockworks/ui/utils';

export interface Props {
    direction: string;
    className?: string;
}

const SortChevron = ({ direction, className }: Props) => {
    return direction === 'asc' ? (
        <ChevronUpIcon className={cn('w-3 h-3 text-brand', className)} />
    ) : (
        <ChevronDownIcon className={cn('w-3 h-3 text-brand', className)} />
    );
};

export default SortChevron;
